import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
} from '@material-ui/core'
import { Clear, ExpandLess, ExpandMore } from '@material-ui/icons'
import React from 'react'
import sendRequest from '../../utils/api'
export default function AdminOption() {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClearCategoryCached = () => {
    sendRequest({
      url: `/publisher/clear_category_cache`,
      method: 'PUT',
    }).then(() => {
      window.location.reload()
    })
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        Admin
        {open ? <ExpandLess /> : <ExpandMore />}
      </span>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuList>
          <MenuItem onClick={handleClearCategoryCached}>
            <ListItemIcon style={{ minWidth: '28px' }}>
              <Clear fontSize="small" />
            </ListItemIcon>
            <ListItemText>Clear Cached</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </div>
  )
}
